// src/crm/conversations/useSendMessage.ts
import { useMutation, type QueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'
import type { Message, MessageChannel, MessageDirection } from '../../lib/types'

export type SendMessageInput = {
  creatorId: string
  channel: MessageChannel
  direction: MessageDirection
  subject?: string | null
  body: string
  send?: boolean
}

export function useSendMessage(creatorId: string | null, queryClient: QueryClient) {
  return useMutation({
    mutationFn: (data: SendMessageInput) =>
      api.post<{ message: Message }>('/api/messages', data).then((r) => r.message),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['conversation', creatorId] })
    },
  })
}
